<template>
    <div class="timeline-event-labwork">
        <div class="timeline-event-labwork__title">
            {{ title }}
            <a :href="print_url" target="_blank">
                <i class="fas fa-print"></i>
            </a>
        </div>
        <div class="timeline-event-labwork__subtitle">
            {{ subtitle }}
        </div>
        <div class="timeline-event-labwork__text" v-html="text">
        </div>
    </div>
</template>

<script>
export default {
    props: ['event', 'entity', 'doctor_names'],
    computed: {
        print_url() {
            return `/customer/${this.entity.customer_id}/document/${this.entity.id}/pdf`;
        },
        text() {
            return this.entity.content;
        },
        title() {
            return this.entity.title;
        },
        subtitle() {
            const custom_fields = JSON.parse(this.entity.custom_fields);
            const cost = Number.parseFloat(custom_fields.lab_work_cost);
            const lab_id = Number.parseInt(custom_fields.laboratory_id);
            const lab = this.clinic.laboratories[lab_id] || null;

            let fragments = [];

            if (lab) {
                fragments.push(`Laboratorio: ${lab.name}`);
            };

            if (cost > 0) {
                fragments.push('Coste: ' + WabiDent.fmtMoney(cost));
            };

            return fragments.join(' - ');
        },
        ...mapGetters(['msgwindow', 'errorwindow', 'clinic'])
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style lang="scss">
.timeline-event-labwork {
    a {
        color: var(--theme-color);

        &:hover {
            color: var(--theme-color-highlight);
        }
    }

    &__title {
        margin-top: 15px;
        font-size: 15px;
        font-weight: 700;
    }

    &__subtitle {
        margin-top: 15px;
        font-size: 12px;
        font-weight: 500;
    }

    &__text {
        font-size: 14px;
        font-weight: 500;

        p {
            margin-bottom: 8px;
        }

        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
